<template>
  <div class="centerx" id="auto-checkout-popup">
    <vs-popup class="auto-checkout-popup" title="Checkout Info" :active.sync="popupConfigNew.isOpen" fullscreen>
        <div class="popup-new-ver-content">
            <div class="lg:flex h-full">
                <div class="lg:w-2/3 w-full flex flex-col align-center position-relative">
                    <div class="w-full h-full overflow-auto flex flex-col align-center left-content left-responsive">
                        <div class="w-full pt-6 px-6 service-list" style="transform: translateX(2px);" v-if="this.popupConfigNew && this.popupConfigNew.item_info">
                          <transition-group name="list">
                            <div class="add-more-service" :key="-2">
                              <vx-card class="flex align-center justify-center cursor-pointer mb-6 add-card" @click="changeStatusService">
                                <feather-icon icon="PlusIcon" svgClasses="h-8 w-8 stroke-current mt-2" />
                              </vx-card>
                            </div>
                            <div v-for="(service,index) in staff_service" :key="service.staff_service_key" class="pb-6">
                                <vx-card class="cursor-pointer" v-if="service.service" @click="(getItemToShow(service, index))">
                                    <div class="flex">
                                        <div class="vx-col w-1/12 flex justify-center font-bold text-lg service-index" :class="{'align-center': itemToShow != index}">{{index + 1}}</div>
                                        <div class="w-11/12 pr-3">
                                            <div class="flex justify-between">
                                                <div class="w-2/3 pr-6">
                                                    <div class="font-bold text-xl service-name vertical-middle">{{service.service.name}}</div>
                                                    <div class="text-grey-custom text-sm mt-2" v-if="service.staff">
                                                    <div class="flex align-center">
                                                        <vs-avatar class="ml-0 mr-2 border-2 border-solid border-grey text-md" size="25px" :text="StringHelper.changeFormatAvatar(service.staff.name)"
                                                        :src="service.staff.image_url" :color="service.staff.color_code"></vs-avatar>
                                                        <div class="staff-name">{{service.staff.name}}</div>
                                                    </div>
                                                    </div>
                                                </div>
                                                <div class="flex" :class="{'align-start': itemToShow == index, 'align-center': itemToShow != index}">
                                                    <div v-if="service.service_price != null">
                                                      ${{service.service_price}}
                                                    </div>
                                                    <div v-else>
                                                      $0.00
                                                    </div>
                                                    <feather-icon icon="XIcon" svgClasses="w-5 h-5 stroke-current text-danger ml-3" @click.stop="removeItem(index)"/>
                                                </div>
                                            </div>
                                            <transition name="list">
                                                <div class="sm:flex mt-6" v-if="itemToShow == index">
                                                    <div class="sm:w-1/2 sm:mr-6 mb-5 sm:mb-0">
                                                        <label class="text-sm">Price</label>
                                                        <vs-input @input="changePrice($event,index)" icon="attach_money" class="w-full" :maxlength="8" v-model="service.service_price" v-on:keypress="isNumber($event)"/>
                                                    </div>
                                                    <div class="sm:w-1/2">
                                                        <div class="flex flex-col justify-end h-full add-staff">
                                                          <vs-button color="dark" class="w-full border-custom" icon-pack="material-icons" icon="edit" @click="openStaffPopup(service)" v-if="service.staff"
                                                           style="background: #fff !important; color: #000;">
                                                            Edit Staff
                                                          </vs-button>
                                                          <vs-button color="dark" class="w-full border-custom" icon-pack="feather" icon="icon-plus" @click="openStaffPopup(service)" v-else
                                                           style="background: #fff !important; color: #000;">
                                                            Add Staff
                                                          </vs-button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </transition>
                                        </div>
                                    </div>
                                </vx-card>
                            </div>
                          </transition-group>
                        </div>
                        <div class="w-full px-6">
                            <div class="promo-redemp-total-container flex py-6 text-normal">
                                <div class="w-1/2 promo-redemp">

                                    <vs-tabs :color="colorx" v-if="checkout_info">
                                      <vs-tab @click="colorx = 'primary'" :label="`Promotion (${checkout_info.list_promotion.length})`">
                                        <div class="con-tab-ejemplo p-2" v-if="checkout_info && checkout_info.list_promotion">
                                          <checkout-promotion :popupConfigPromotion="popupConfigPromotion" :promoData="checkout_info.list_promotion" @AddPromotion="addPromotion" @ClearPromo="removePromo"></checkout-promotion>
                                        </div>
                                      </vs-tab>
                                      <vs-tab @click="colorx = 'primary'" :label="`Redemption (${checkout_info.list_redeem.length})`">
                                        <div class="con-tab-ejemplo p-2" v-if="checkout_info && checkout_info.list_redeem">
                                          <checkout-redeem :popupConfigRedemtion="popupConfigRedemtion" :redemtionData="checkout_info.list_redeem" @AddRedemtion="addRedemtion"></checkout-redeem>
                                        </div>
                                      </vs-tab>
                                    </vs-tabs>
                                    <input name="radio" id="temp-radio-promo" type="radio" hidden>
                                </div>
                                <div class="w-1/2 md:pl-6 promo-redemp-total">
                                    <div class="flex justify-between pr-2 py-2">
                                        <div>Total</div>
                                        <div v-if="current.length >=1">${{parseFloat(current).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}}</div>
                                        <div v-else>$0</div>
                                    </div>

                                    <vs-divider class="m-0"></vs-divider>
                                    <div class="py-3 pb-4 total-content">
                                        <transition-group name="list">
                                          <div v-if="this.promotion_added.checked == true" :key="1 + 'selected_promo'">
                                              <div class="flex justify-between pl-2 pr-1" v-if="promotion_added.campaign.logic_type=='percent'">
                                                  <div @click="removePromo"><feather-icon icon="XIcon" svgClasses="w-4 stroke-current text-danger cursor-pointer remove-promo-redemp-icon"/></div>
                                                  <div class="popup-new-ver-ellipsis">{{promotion_added.campaign.name}}</div>
                                                  <div>- {{promotion_added.campaign.logic_value}}%</div>
                                              </div>
                                              <div class="flex justify-between pl-2 pr-1" v-if="promotion_added.campaign.logic_type=='usd'">
                                                  <div @click="removePromo"><feather-icon icon="XIcon" svgClasses="w-4 stroke-current text-danger cursor-pointer remove-promo-redemp-icon"/></div>
                                                  <div class="popup-new-ver-ellipsis">{{promotion_added.campaign.name}}</div>
                                                  <div>- ${{promotion_added.campaign.logic_value}}</div>
                                              </div>
                                          </div>
                                        </transition-group>

                                        <transition-group name="list">
                                          <div v-for="(redem) in redemtion_added" :key="redem.id + 'selected_redem'">
                                              <div class="flex justify-between pl-2 pr-1" v-if="redem.checked == true">
                                                  <div @click="removeRedem(redem)"><feather-icon icon="XIcon" svgClasses="w-4 stroke-current text-danger cursor-pointer remove-promo-redemp-icon"/></div>
                                                  <div class="popup-new-ver-ellipsis">{{redem.content}}</div>
                                                  <div v-if="redem.logic_type=='usd'">- ${{redem.logic_value}}</div>
                                                  <div v-else>- {{redem.logic_value}}%</div>
                                              </div>
                                          </div>
                                        </transition-group>
                                    </div>
                                    <vs-divider class="m-0"></vs-divider>

                                    <div class="flex align-center justify-between font-semibold text-2xl pt-2">
                                        <div>Balance</div>
                                        <div v-if="current.length >=1">${{reCalculator().toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}}</div>
                                        <div v-else>$0</div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="lg:w-1/3 lg:pt-0 pt-5 w-full h-full position-relative border-left-custom">
                    <div>
                        <div class="w-full" v-if="popupConfigNew.item_info.customer">
                            <div class="flex justify-between align-center pb-4">
                                <div class="flex align-center">
                                  <div v-if="popupConfigNew.item_info.customer.image_url">
                                    <vs-avatar :src="popupConfigNew.item_info.customer.image_url" size="60px" class="mx-5 text-4xl" />
                                  </div>
                                  <div v-else>
                                    <vs-avatar :text="StringHelper.changeFormatAvatar(popupConfigNew.item_info.customer.full_name)" size="60px" class="mx-5 text-4xl" />
                                  </div>
                                    <div>
                                        <div class="flex font-bold text-lg justify-between">
                                            <div class="tooltip">
                                              <vs-button class="mr-3 customer-name" @click.stop>{{popupConfigNew.item_info.customer.full_name}}</vs-button>
                                              <span class="tooltiptext" style="word-wrap: break-word; word-break: break-word;">{{popupConfigNew.item_info.customer.full_name}}</span>
                                            </div>
                                            <vs-alert :color="getMemberTypeColor(popupConfigNew.item_info.customer.type)" class="flex align-center justify-center text-sm customer-type">{{popupConfigNew.item_info.customer.type}}</vs-alert>
                                        </div>
                                        <div class="flex text-grey-custom text-sm mt-2">
                                            <feather-icon icon="PhoneIcon" svgClasses="h-4 w-4 mr-1" />
                                            <span>{{StringHelper.phoneNumberFormat(popupConfigNew.item_info.customer.phone, true)}}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="w-full toggle-content">
                        <div class="w-full h-full overflow-hidden" v-show="!showInfo">
                            <div class="mb-4" v-if="popupConfigNew.item_info.customer">
                                <div class="vx-row mx-5 point-visit-time">
                                    <div class="vx-col w-6/24 mb-2 p-0">
                                        <div class="text-sm text-grey-custom">Points</div>
                                        <p class="text-sm p-0 pt-1">{{popupConfigNew.item_info.customer.current_point}} Pts</p>
                                    </div>
                                    <div class="vx-col w-6/24 mb-2 p-0">
                                        <div class="text-sm text-grey-custom">Visit</div>
                                        <p class="text-sm p-0 pt-1" v-if="popupConfigNew.item_info.customer.visit_count > 1">{{popupConfigNew.item_info.customer.visit_count}} times</p>
                                        <p class="text-sm p-0 pt-1" v-else>{{popupConfigNew.item_info.customer.visit_count}} time</p>
                                    </div>
                                    <div class="vx-col w-12/24 mb-2 p-0">
                                        <div class="text-sm text-grey-custom">Check in</div>
                                        <p class="text-sm p-0 pt-1">{{changeFormat(popupConfigNew.item_info.create_at)}}</p>
                                    </div>
                                </div>
                                <div class="flex ml-5 mr-1 align-center cursor-pointer" @click="popupNote = true">
                                    <div class="flex align-center text-sm break-word p-0 text-grey-custom" style="height: 35px">
                                        <span class="font-semibold">Note:</span>
                                        <div class="text-grey-custom ml-2 break-word popup-new-ver-note note-content" v-if="checkout_info">{{note_view}}</div>
                                    </div>
                                    <div class="ml-auto">
                                        <i class="material-icons ml-auto cursor-pointer gradient gradient-primary no-shadow text-white user-select-none popup-new-ver-edit-icon">create</i>
                                    </div>
                                </div>

                                <vs-popup class="checkout-popup-note" title="Note" :active.sync="popupNote">
                                    <div class="pt-4">
                                        <vs-textarea :maxlength="1024" v-model="note" height="200"/>
                                        <btn-custom @click="updateNote">Save</btn-custom>
                                    </div>
                                </vs-popup>
                            </div>
                            <!-- <vs-divider class="m-0 pl-4"></vs-divider> -->
                            <appointment-tabs style="padding-left: 15px;" :customerId="customerId" :key="customerId"></appointment-tabs>
                            <vs-divider class="m-0 pl-4"></vs-divider>
                            <div class="flex align-center pt-4 pb-1 w-full pl-base pr-4 con-btn-checkout">
                                <vs-button class="font-bold gradient gradient-primary no-shadow w-1/2 mr-3" @click="reprint">Re-print</vs-button>
                                <vs-button class="font-bold gradient gradient-primary no-shadow w-1/2 ml-3" @click="redeem">Redeem</vs-button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </vs-popup>
    <div v-if="testPromotion == 1">
      <vs-popup-promotion :popupConfigPromotion="popupConfigPromotion" :promoData="checkout_info.list_promotion" @AddPromotion="addPromotion" @ClearPromo="removePromo"></vs-popup-promotion>
    </div>
    <div v-if="test == 1">
      <vs-popup-redemtion :popupConfigRedemtion="popupConfigRedemtion" :redemtionData="checkout_info.list_redeem" @AddRedemtion="addRedemtion"></vs-popup-redemtion>
    </div>
    <div v-if="this.key_view_invoice == 1 && popupConfigNew.item_info && popupConfigNew.item_info.customer">
        <vs-view-invoice :promotionAdded="promotion_added" :redemtionAdded="redemtion_added" :popupViewInvoice="popupViewInvoice" :staffService="staff_service_for_invoice" :total_price="total_price" :subtotal="subtotal" :key="view_invoice_key" :customerInfo="popupConfigNew.item_info.customer"></vs-view-invoice>
    </div>
    <vs-popup-service :popupService="popupService" :add_service_temp="add_service_temp" :key="key_service" @AddService="addService"></vs-popup-service>
    <checkout-staff-popup :popupStaff="popupStaff" @SelectStaff="selectStaff"></checkout-staff-popup>
  </div>
</template>

<script>
    import { StringHelper } from '../../models/string_helper'
    import {changeFormatWithDateTime} from '../../helper/datetimeHelper';
    import vSelect from 'vue-select'
    export default {
        name: "vs-auto-checkout-popup",
        components: {
            ListItem: () => import("./ListItem.vue"),
            ListRadioItem: () => import("./ListRadioItem.vue"),
            'v-select': vSelect,
        },
        props: {
            popupConfigNew: {
                type: Object,
                required: true
            },
            currentPage: {
                type: Number,
                default: 1
            },
            itemsPerPage: {
                type: Number,
                default: 10
            },
            fromAppointment: {
              type: Boolean,
              default: false
            },
            search: {
              type: String
            },
            filter: {
              type: Object
            },
            sort_by: {
              type: Object
            }
        },
        data() {
            let note_temp = '';
            let staff_service_key = -1;
            let staff_service = [
              {
                service: null,
                staff: null,
                service_price: null,
                staff_service_key: -1
              }
            ];
            let add_service_temp = [];
            let current = "0";
            let customerId = null;
            if(this.popupConfigNew.item_info.check_out != null){
              this.$store.dispatch("checkin/GET_CHECKOUT_INFO", {id: this.popupConfigNew.item_info.check_out.id}).then(() => {
                  if(this.checkout_info.customer) {
                      note_temp = this.checkout_info.customer.note;
                  }
              });
              customerId = this.popupConfigNew.item_info.customer_id;
            }
            return {
                customerId,
                staff_service_key,
                view_invoice_key: 0,
                test: 0,
                key_index: 0,
                StringHelper,
                input_price:'',
                currentPageService: 1,
                itemsPerPageService: 10,
                currentPageStaff: 1,
                itemsPerPageStaff: 10,
                colorx: 'primary',
                promotion_added:{},
                redemtion_added: [],
                staff_service,
                selectedStaff: {},
                total_price: 0,
                subtotal: 0,
                discount_value: 0,
                current,
                number: "0",
                promotion: '',
                itemToShow: {},
                note_temp,
                popupNote: false,
                showInfo: false,
                popupConfigPromotion: {
                  isOpen: false,
                },
                popupConfigRedemtion: {
                  isOpen: false,
                },
                popupService: {
                  isOpen: false,
                  item_info: {}
                },
                popupTip: {
                  isOpen: false,
                },
                popupViewInvoice: {
                  isOpen: false,
                  item_info: {},
                },
                popupStaff: {
                  isOpen: false,
                  item_info: {}
                },
                fn_price: {},
                staff_code_open: false,
                staff_code: {
                    number_1: "",
                    number_2: "",
                    number_3: ""
                },
                confirm: false,
                point_bonus: 0,
                key_view_invoice: 0,
                promotion_code: '',
                testPromotion: 0,
                checkBoxService: [],
                checkBoxStaff: [],
                key_service: 0,
                name: '',
                add_service_temp,
                staff_service_for_invoice: {},
                note_view: '',
                action_type: '',
                isOpenLoading: false,
                is_change_camp: false
            }
        },
        watch:{
          popupConfigNew: {
                immediate: true,
                deep: true,
                handler() {
                    if(this.popupConfigNew.isOpen) {
                        document.body.classList.add('overflow-hidden');
                        document.body.style.position = '';
                        document.body.style.top = '';
                        window.scrollTo(0, parseInt(scrollY || '0') * -1);
                    } else {
                        document.body.classList.remove('overflow-hidden');
                        this.showInfo = false;
                        this.current = '';
                        this.currentPageStaff = 1;
                        // this.promotion_added = {};
                        // this.redemtion_added = [];
                    }
                }
            },
            popupNote: {
                immediate: true,
                deep: true,
                handler() {
                  if(this.popupNote) {
                    this.note_temp = this.note_view;
                  }
                }
            },
            checkout_info: {
              immediate: true,
              deep: true,
              handler() {
                // console.log(this.checkout_info)
                if(this.checkout_info && this.checkout_info.customer) {
                  this.note_temp = this.checkout_info.customer.note;
                  this.note_view = this.note_temp;
                }
                if(this.checkout_info && this.checkout_info.check_in && this.is_change_camp == false) {
                  this.staff_service = [];
                  this.add_service_temp = [];
                  this.current = '0';
                  if (this.checkout_info.check_in.customer_checkin_services) {

                    for(let i = 0; i < this.checkout_info.check_in.customer_checkin_services.length; i++) {
                      this.staff_service.push({
                        service: this.checkout_info.check_in.customer_checkin_services[i].service,
                        staff: this.checkout_info.check_in.customer_checkin_services[i].staff,
                        service_price: this.checkout_info.check_in.customer_checkin_services[i].price,
                        staff_service_key: i
                      });
                      this.add_service_temp.push({
                        service: this.checkout_info.check_in.customer_checkin_services[i].service,
                        staff: this.checkout_info.check_in.customer_checkin_services[i].staff,
                        service_price: this.checkout_info.check_in.customer_checkin_services[i].price,
                        staff_service_key: i
                    });
                    this.staff_service_key = i;
                    if(!isNaN(parseFloat(this.checkout_info.check_in.customer_checkin_services[i].price))){
                      this.current = (parseFloat(this.current) + parseFloat(this.checkout_info.check_in.customer_checkin_services[i].price)).toString();
                    }
                  }
                }
                }
              }
            }
        },
        methods: {
          openLoadingInDiv(){
            this.$vs.loading({
              container: '#checkout-popup-new-ver',
              scale: 0.8
            })
            this.isOpenLoading = true;
            setTimeout( ()=> {
              if(this.isOpenLoading) {
                this.closeLoading();
                this.$vs.dialog({
                  color: 'danger',
                  title: 'Notification',
                  text: this.action_type + ' failed',
                  acceptText: 'OK'
                })
              }
            }, 10000);
          },
          closeLoading() {
            this.$vs.loading.close('#checkout-popup-new-ver > .con-vs-loading');
            this.isOpenLoading = false;
          },
          openStaffPopup(service) {
            this.popupStaff.isOpen = true;
            this.popupStaff.item_info = service;
          },
          selectStaff(staff) {
            this.popupStaff.item_info.staff = staff;
            this.popupStaff.isOpen = false;
            this.saveServiceStaff();
          },
            changePrice(event,index){
              if (!isNaN((event))) {
                this.staff_service[index].service_price = (event);
              } else {
                this.staff_service[index].service_price = 0;
              }
              this.getTotal();

              if (this.timer) {
                clearTimeout(this.timer);
                this.timer = null;
              }
              if(!this.isOpenLoading) {
                this.$vs.loading({
                  container: "#app",
                  scale: 0.8
                });
                this.isOpenLoading = true;
              }
              this.timer = setTimeout(() => {
                this.saveServiceStaff();
                this.$vs.loading.close("#app > .con-vs-loading");
              }, 1000);
            },
            getTotal() {
              let total = 0;
              for (let i = 0; i < this.staff_service.length; i++) {
                if (!isNaN(parseFloat(this.staff_service[i].service_price))) {
                  total = parseFloat(total) + parseFloat(this.staff_service[i].service_price);
                }
              }
              if (isNaN(total)) {
                this.current = 0;
              } else {
                this.current = total.toString(10);
              }
            },
            redeem(){
              let checkRedeem = [];
              for(let i=0;i< this.redemtion_added.length;i++){
                checkRedeem.push(this.redemtion_added[i].id);
                this.point_bonus = this.point_bonus + this.redemtion_added[i].point;
              }
              if(this.checkout_info){
                if(this.checkout_info.check_in){
                   const obj = {
                    checkin_id: this.checkout_info.check_in.id,
                    redeem_list: String(checkRedeem),
                    promotion_code: this.promotion_code,
                    keyword: this.search
                  }
                  if (this.filter.id != 1) {
                    obj.type = this.filter.name;
                  }
                  if(this.sort_by.id == 2) {
                    obj.sort = this.sort_by.name;
                  }
                  this.openLoadingInDiv();
                  this.$store.dispatch("checkin/CHECKOUT_REDEEM" , obj).then(() => {
                    this.closeLoading();
                    this.popupConfigNew.isOpen = false;
                    this.$vs.notify({
                      title:'Notification',
                      text: "Checkout Success",
                      color:'success',
                      position:'top-right'})
                  }).catch((err) => {
                    this.closeLoading();
                      this.$vs.notify({
                      title:'Notification',
                      text: err,
                      color:'danger',
                      position:'top-right'})
                  })
                }
              }
            },
            f_submit() {
              let checkRedeem = [];
              for(let i=0;i< this.redemtion_added.length;i++){
                checkRedeem.push(this.redemtion_added[i].id);
                this.point_bonus = this.point_bonus + this.redemtion_added[i].point;
              }
              if(this.checkout_info){
                if(this.checkout_info.check_in){
                  const obj = {
                    promotion_code: this.promotion_code,
                    point_bonus: Math.floor(this.total_price),
                    checkin_id: this.checkout_info.check_in.id,
                    staff_code: 999,
                    redeem_list: String(checkRedeem),
                    discount_value: Math.round(this.discount_value),
                    total_price: +(Math.round(this.total_price + "e+2") + "e-2"),
                  }
                  this.subtotal = this.current;
                  this.action_type = "Checkout submit";
                  this.openLoadingInDiv();
                  this.$store.dispatch("checkin/CHECKOUT_SUBMIT" , obj).then(() => {
                    this.closeLoading();
                    this.popupConfigNew.isOpen = false;
                    if (this.popupConfigNew.fromAppointment == true) {
                      this.$emit('closePopup');
                    } else {
                      this.subtotal = parseFloat(this.current)
                      this.popupViewInvoice.isOpen = true;
                      this.key_view_invoice = 1;
                    }
                    this.$vs.notify({
                    title:'Notification',
                    text: "Checkout Success",
                    color:'success',
                    position:'top-right'})
                  }).catch((err) => {
                    this.closeLoading();
                    this.key_view_invoice = 0;
                      this.$vs.notify({
                      title:'Notification',
                      text: err,
                      color:'danger',
                      position:'top-right'})
                  })
                }
              }
            },
            saveServiceStaff(){
              const data_temp = [];
              for(let i = 0; i < this.staff_service.length; i++) {
                data_temp.push({
                  service_id: this.staff_service[i].service.id || this.staff_service[i].service.service_id,
                  staff_id: this.staff_service[i].staff ? this.staff_service[i].staff.user_id : null,
                  price: this.staff_service[i].service_price ? parseFloat(this.staff_service[i].service_price) : null
                })
              }
              // if(data_temp.length > 0) {
                const data = {
                  checkin_id: this.popupConfigNew.item_info.id,
                  // id: this.checkout_info.id,
                  data: data_temp,
                  page: this.currentPage,
                  'per-page': this.itemsPerPage,
                  keyword: this.search
                }
                if (this.filter.id != 1) {
                  data.type = this.filter.name;
                }
                if(this.sort_by.id == 2) {
                  data.sort = this.sort_by.name;
                }
                if(!this.isOpenLoading) {
                  this.openLoadingInDiv();
                }
                this.$store.dispatch('checkin/UPDATE_SERVICE_WITH_STAFF_AND_PRICE', data).then(() => {
                  this.closeLoading();
                  this.$vs.notify({
                    title:'Notification',
                    text: "Save Service Staff Success",
                    color:'success',
                    position:'top-right'})
                }).catch(() => {
                  this.closeLoading();
                   this.$vs.notify({
                    title:'Notification',
                    text: "Save Service Staff Failed",
                    color:'danger',
                    position:'top-right'})
                })
              // }
              // console.log(this.staff_service)
              // console.log(this.promotion_added)
            },
            // checkoutSubmit(){
            //   this.view_invoice_key++;
            //   const data_temp = [];
            //   for(let i = 0; i < this.staff_service.length; i++) {
            //     data_temp.push({
            //       service_id: this.staff_service[i].service.id,
            //       staff_id: this.staff_service[i].staff ? this.staff_service[i].staff.user_id : null,
            //       price: this.staff_service[i].service_price ? parseFloat(this.staff_service[i].service_price) : null
            //     })
            //   }
            //   if(data_temp.length > 0) {
            //     const data = {
            //       checkin_id: this.popupConfigNew.item_info.id,
            //       data: data_temp,
            //       page: this.currentPage,
            //       'per-page': this.itemsPerPage
            //     }
            //     this.$store.dispatch('checkin/UPDATE_SERVICE_WITH_STAFF_AND_PRICE', data).then(() => {
            //       this.popupViewInvoice.item_info = this.popupConfigNew.item_info;
            //       this.staff_service_for_invoice = this.staff_service;
            //       this.f_submit();
            //     })
            //   } else {
            //     this.popupViewInvoice.item_info = this.popupConfigNew.item_info;
            //     this.staff_service_for_invoice = this.staff_service;
            //     this.f_submit();
            //   }
            // },
            checkout(){
              this.popupViewInvoice.item_info = this.popupConfigNew.item_info;
              this.staff_code_open = true;
            },
            selectId(e, service) {
              for(let i = 0; i < this.staff_service.length; i++){
                if(e.user_id && service.staff_service_key == this.staff_service[i].staff_service_key){
                  this.staff_service[i].staff = e;
                }
              }
            },
            addService(service) {
              this.staff_service_key++;
              let temp = {
                service: service,
                staff: null,
                service_price: service.price,
                staff_service_key: this.staff_service_key
              }

              this.add_service_temp.push(temp);
              this.staff_service.push(temp);
              this.popupService.isOpen = false;
              this.getTotal();
              this.saveServiceStaff();
            },
            removeItem(index){
              let temp = null;

              for(let i = 0; i < this.staff_service.length; i++) {
                if(i == index) {
                  temp = this.staff_service[i];
                  this.staff_service.splice(i, 1);
                  break;
                }
              }

              if(temp && temp.service) {
                for(let i = 0; i < this.add_service_temp.length; i++) {
                  if(temp.service.id == this.add_service_temp[i].service.id) {
                    this.add_service_temp.splice(i, 1);
                    break;
                  }
                }
              }

              this.getTotal();
              this.saveServiceStaff();
            },
            getItemToShow(service, index){
              // if(this.itemToShow == index) {
              //   this.itemToShow = {};
              // } else {
                this.itemToShow = index;
              // }
              this.$store.dispatch("checkin/GET_STAFF_BY_SERVICE", {id: service.service.id});
              if(service.staff) {
                this.name = service.staff.name;
              } else {
                this.name = '';
              }
            },
            changeFormat(day){
              if(day) {
                return changeFormatWithDateTime(day);
              } else {
                return 'N/A';
              }
            },
            popupAddTip(){
                this.popupTip.isOpen = true;
            },
            clearRadio(){
                document.getElementById('temp-radio-promo').click();
            },
            removeRedem(redem){
                this.is_change_camp = true;
                for(let i=0;i<this.checkout_info.list_redeem.length;i++){
                if(this.checkout_info.list_redeem[i].id == redem.id){
                    if(this.checkout_info.list_redeem[i].checked) {
                        this.$store.dispatch('checkin/CHANGE_STATUS_REDEMPTION', this.checkout_info.list_redeem[i]);
                        this.redemtion_added = this.removeItemFromArray(this.redemtion_added, this.checkout_info.list_redeem[i]);
                        this.abc++;
                        return ;
                    }
                }
                }
            },
            removeItemFromArray(arr, item) {
                for(let i = 0; i < arr.length; i++) {
                    if(arr[i].id == item.id) {
                        arr.splice(i, 1);
                        return arr;
                    }
                }
            },
            removePromo(){
                this.is_change_camp = true;
                this.$store.dispatch('checkin/CHANGE_STATUS_PROMOTION', this.promotion_added);
                this.promotion_added = {},
                this.clearRadio();
            },
            changeStatus() {
                this.showInfo = !this.showInfo;
            },
            addRedemtion(data) {
                this.is_change_camp = true;
                if(data.checked == true) {
                  let tempTotal = 0;
                  for (let i = 0; i < this.redemtion_added.length; i++){
                    tempTotal += this.redemtion_added[i].point;
                  }
                  if (tempTotal + data.point > this.checkout_info.customer.current_point){
                    this.$store.dispatch('checkin/CHANGE_STATUS_REDEMPTION', data);
                    this.$vs.notify({
                      title:'Error',
                      text:'You have not enough point!',
                      color:'danger',
                      position:'top-right'
                    });
                    return;
                  }
                  this.redemtion_added.push(data);
                }else{
                    for(let i =0;i<this.redemtion_added.length;i++) {
                        if(data.id == this.redemtion_added[i].id) {
                            this.redemtion_added.splice(i,1);
                            return;
                        }
                    }
                }
            },
            changeStatusService(){
                this.popupService.isOpen = true;
                if(this.popupConfigNew.item_info && this.popupConfigNew.item_info.services) {
                  this.popupService.item_info = this.popupConfigNew.item_info.services;
                }
                this.key_service++;
            },
            addPromotion(data){
              this.is_change_camp = true;
              this.promotion_added = data;
              this.promotion_code = this.promotion_added.code;
            },
            popupPromotion(){
                this.testPromotion = 1;
                this.popupConfigPromotion.isOpen = true;
            },
            popupRedemtion(){
                this.test = 1;
                this.popupConfigRedemtion.isOpen = true;
            },
            clearPromotion(){
                for(let i = 0;i<this.checkout_info.list_promotion.length;i++){
                    if(this.checkout_info.list_promotion[i].checked) {
                        this.$store.dispatch('checkin/CHANGE_STATUS_PROMOTION', this.checkout_info.list_promotion[i]);
                    }
                }
                this.clearRadio();
                this.promotion_added = {};
            },
            clearRedemption() {
                for(let i = 0; i < this.redemtion_list.length; i++) {
                    if(this.redemtion_list[i].checked) {
                        this.$store.dispatch('checkin/CHANGE_STATUS_REDEMPTION', this.redemtion_list[i]);
                    }
                }
                this.redemtion_added = [];
            },
            closePopup(){
                this.popupConfigNew.isOpen = false;
                this.current = "";
                this.promotion_added = {};
                // console.log('a')
            },
            reCalculator(){
                let amountCurrent = parseFloat(this.current);
                let promotion = 0;
                if(this.promotion_added && this.promotion_added.campaign){
                  if(this.promotion_added.campaign.logic_type == "percent"){
                      promotion = (promotion + this.promotion_added.campaign.logic_value/100)*amountCurrent;
                  }else if(this.promotion_added.campaign.logic_type == "usd"){
                      promotion = promotion + parseFloat(this.promotion_added.campaign.logic_value);
                  }
                }
                let redemtion = 0;
                if(this.redemtion_added.length != 0){
                  for(let i=0;i<this.redemtion_added.length;i++){
                    if(this.redemtion_added[i].logic_type == "percent"){
                      redemtion = parseFloat(redemtion) + parseFloat(this.redemtion_added[i].logic_value/100)*amountCurrent;
                    }else if(this.redemtion_added[i].logic_type == "usd"){
                      redemtion = parseFloat(redemtion) + parseFloat(this.redemtion_added[i].logic_value);
                    }
                  }
                }
                if(amountCurrent <= (redemtion + promotion)){
                  this.discount_value = redemtion + promotion;
                  return 0;
                }else{
                  this.total_price = amountCurrent - redemtion - promotion;
                  this.discount_value = redemtion + promotion;
                  return amountCurrent - redemtion - promotion;
                }
            },
            deleteNumStaffCode(){
              if(this.staff_code.number_1 != ''){
                if(this.staff_code.number_2 != ''){
                  if(this.staff_code.number_3 != ''){
                    this.staff_code.number_3 = '';
                  }else{
                    this.staff_code.number_2 = '';
                  }
                }else{
                  this.staff_code.number_1 = '';
                }
                if(this.staff_code.number_3 != ''){
                  this.confirm = true;
                }else{
                  this.confirm = false;
                }
              }
            },
            appendStaffCode(number){
              if(this.staff_code.number_3 == ''){
                if(this.staff_code.number_2 == ''){
                  if(this.staff_code.number_1 == ''){
                    this.staff_code.number_1 = number;
                  }else{
                    this.staff_code.number_2 = number;
                  }
                }else{
                  this.staff_code.number_3 = number;
                }
                if(this.staff_code.number_3 != ''){
                  this.confirm = true;
                }
              }
            },
            append(number) {
                if(this.current.length <= 8){
                    if (this.operatorClicked) {
                    this.current = "";
                    this.operatorClicked = false;
                    }
                    if(this.current == '0' && number != '.') {
                        this.current = '';
                    }
                    this.current = `${this.current}${number}`;
                }
            },
            dot() {
                if(this.current == '') {
                    this.append('0');
                }
                if (this.current.indexOf(".") === -1) {
                    this.append(".");
                }
            },
            deleteNum(){
                return this.current = this.current.substring(0, this.current.length - 1);
            },
            isNumber: function(evt) {
                evt = (evt) ? evt : window.event;
                var charCode = (evt.which) ? evt.which : evt.keyCode;
                if (((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) || (charCode == 46 && this.input_price.indexOf(".") != -1)) {
                    evt.preventDefault();
                } else {
                    return true;
                }
            },
            changeStatusRadio(item) {
                for(let i = 0; i < this.checkout_info.list_promotion.length; i++) {
                    if(this.checkout_info.list_promotion[i].checked) {
                        this.$store.dispatch('checkin/CHANGE_STATUS_PROMOTION', this.checkout_info.list_promotion[i]);
                    }
                }
                for(let i = 0; i < this.checkout_info.list_promotion.length; i++) {
                    if(this.checkout_info.list_promotion[i].id == item.id) {
                        if(this.checkout_info.list_promotion[i].checked != true) {
                            this.$store.dispatch('checkin/CHANGE_STATUS_PROMOTION', this.checkout_info.list_promotion[i]);
                        }
                    }
                }
            },
            getMemberTypeColor(member_type) {
                if (member_type == "new") return "success";
                if (member_type == "regular") return "primary";
                if (member_type == "vip") return "danger";
                if (member_type == "atrisk") return "warning";
                return "purple";
            },
            updateNote() {
                if(this.checkout_info && this.checkout_info.customer) {
                    const obj = {
                        phone: this.checkout_info.customer.phone,
                        note: this.note,
                        page: this.currentPage,
                        "per-page": this.itemsPerPage,
                        id: this.checkout_info.id
                    }
                    this.$store.dispatch('checkin/UPDATE_CUSTOMER_NOTE', obj).then(() => {
                        this.$vs.notify({
                        title:'Notification',
                        text:'Update Customer Note Successful',
                        color:'success',
                        position:'top-right'});
                        this.popupNote = false;
                        this.note_view = this.note_temp;
                        this.$emit("UpdateNote");
                    }).catch(() => {
                        this.$vs.notify({
                        title:'Notification',
                        text:'Update Customer Note Fail',
                        color:'danger',
                        position:'top-right'});
                        this.popupNote = false;
                    })

                }
            },
            reprint(){
              let link = 'gocheckin://' + this.checkout_info.check_in.id;
                window.location.href = link;
            }
        },
        computed:{
          customerHistory() {
            return this.$store.getters["customer/history"];
          },
          checkout_info(){
            return this.$store.state.checkin.checkoutInfo;
          },
          redemtion_list() {
            return this.$store.getters['checkin/redemptionList'];
          },
          promotion_list() {
            return this.$store.getters['checkin/promotionList'];
          },
          note: {
            get() {
              return this.note_temp;
            },
            set(value) {
              this.note_temp = value;
            }
          }
        },
    };
</script>
